import { useCanManageWorkspaceBilling } from "@hooks/permissions/useCanManageWorkspaceBilling";
import {
    OverPageCTA,
    OverPageCTAProps,
} from "@design-system/Banner/OverPageCTA";

export const OverPageBillingCTA: React.FC<OverPageCTAProps> = ({
    cta,
    ...rest
}) => {
    const canManageBilling = useCanManageWorkspaceBilling();

    return <OverPageCTA {...rest} cta={canManageBilling ? cta : null} />;
};
